import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PhoneView from '../views/PhoneView.vue'
import DeviceView from '../views/DeviceView.vue'
import AccountsView from '../views/AccountsView.vue'
import PlansView from '../views/PlansView.vue'
import SignInView from '../views/SignInView.vue'
import ProfileView from '../views/ProfileView.vue'
import store from '../store/index'

const routes = [
  {
    path: '/sign-in',
    name: 'SignIn',
    component: SignInView
  },
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: AccountsView
  },
  {
    path: '/plans',
    name: 'Plans',
    component: PlansView
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView
  },
  {
    path: '/account/:accountId/device/:deviceId',
    name: 'Device ',
    component: DeviceView,
    props: true
  },
  {
    path: '/account/:accountId/device/:deviceId/demo',
    name: 'DeviceIdDemo ',
    component: PhoneView,
    props: true
  },
  {
    path: '/account/device/demo',
    name: 'DeviceDemo',
    component: PhoneView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = (store.state.idToken !== '')
  if (to.name !== 'SignIn' && !isAuthenticated) {
    next({ name: 'SignIn' })
  } else {
    next()
  }
})

export default router
